import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getValidToken } from "../../../utils/tokenManager";

/**
 * Extracted from admin/NewUser.jsx - same validation, same payload
 * shape, same endpoint (POST /api/users).
 */
export function useNewUser() {
  const { t } = useTranslation();
  const initialFormState = { fullName: "", email: "", role: "", workshift: "", phone: "" };

  const [form, setForm] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[\d\s-]{10,}$/;

    if (!form.fullName.trim()) newErrors.fullName = t("validation.requiredField");
    if (!form.email.trim()) {
      newErrors.email = t("validation.requiredField");
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = t("validation.invalidEmail");
    }
    if (!form.role) newErrors.role = t("validation.requiredRole");
    if (!form.workshift) newErrors.workshift = t("validation.requiredWorkshift");
    if (!form.phone.trim()) {
      newErrors.phone = t("validation.requiredField");
    } else if (!phoneRegex.test(form.phone)) {
      newErrors.phone = t("validation.invalidPhone");
    }
    return newErrors;
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrorModal(true);
      setErrors(validationErrors);
      setIsSubmitting(false);
      return;
    }
    const userData = {
      FullName: form.fullName,
      Email: form.email,
      Role: form.role,
      Workshift: form.workshift,
      Phone: form.phone,
    };
    const accessToken = await getValidToken();
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };

    try {
      const { status } = await axios.post(`${process.env.REACT_APP_APIBASEURL}/api/users`, userData, config);
      if (status === 201) {
        setSuccessModal(true);
      }
    } catch (error) {
      const serverData = error.response?.data;
      const errorMessage = serverData ? serverData.details || serverData.error || t("error.generic") : t("error.generic");
      setErrorModal(true);
      setErrors({ submit: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeSuccessModal = () => {
    setSuccessModal(false);
    setForm(initialFormState);
  };

  return {
    form,
    errors,
    isSubmitting,
    successModal,
    errorModal,
    handleChange,
    handleSubmit,
    closeSuccessModal,
    setErrorModal,
  };
}